import { useEffect, useState } from "react";
import { useTranslation } from "../../../../../context/TranslationContext";

const DriverLogs = ({ driverAssignLogs }) => {
  const { t } = useTranslation();

  const [listData, setListData] = useState([]);

  useEffect(() => {
    let tableData = [];
    if (driverAssignLogs.length > 0) {
      for (let item of driverAssignLogs) {
        let online_driver_in_order_zone = [];
        if (item?.online_driver_in_order_zone)
          for (let row of item?.online_driver_in_order_zone)
            online_driver_in_order_zone.push(
              row.firstName + " " + row.lastName
            );

        let drivers_based_on_vehicle_type = [];
        if (item?.drivers_based_on_vehicle_type)
          for (let row of item?.drivers_based_on_vehicle_type)
            drivers_based_on_vehicle_type.push(
              row.firstName +
              " " +
              row.lastName +
              `( ${row?.driverDetail?.vehicleType?.name} )`
            );

        let not_available_driver = [];
        if (item?.not_available_driver)
          for (let row of item?.not_available_driver)
            not_available_driver.push(row.firstName + " " + row.lastName);

        let available_driver = [];
        if (item?.available_driver)
          for (let row of item?.available_driver) {
            let volume = 0;
            for (let itm of item?.available_driver_volume) {
              if (itm.driver_id === row.id) volume = itm.remanining_volume;
            }
            let name = row.firstName + " " + row.lastName;
            if (volume > 0) name = name + `(Available Volume:${volume})`;
            available_driver.push(name);
          }

        let nearest_drivers = [];
        if (item?.nearest_drivers)
          for (let row of item?.nearest_drivers)
            nearest_drivers.push(
              row.firstName +
              " " +
              row.lastName +
              ` ,Distance:` +
              row.distance +
              ` KM`
            );

        tableData.push({
          branchZoneDetail: item?.branchDetails?.zoneDetails[0]?.name,
          branchDetail: item?.branchDetails?.name,
          totalOrderVolume: item?.totalOrderVolume,
          onlineDriver: online_driver_in_order_zone.join(","),
          driversBasedVehicleType: drivers_based_on_vehicle_type.join(","),
          notAvailableDriver:
            not_available_driver.length === 0
              ? "No Driver available"
              : not_available_driver.join(""),
          availableDriver: available_driver.join(","),
          totalSlotDistance: item?.slotsDistanceLogs ? item?.slotsDistanceLogs?.totalDistance : '-',
          orderDistance: item?.slotsDistanceLogs ? item?.slotsDistanceLogs?.orderDistance : '-',
          totalTripDistance: item?.slotsDistanceLogs ? item?.slotsDistanceLogs?.tripDistance : '-',
          nearestDrivers:
            nearest_drivers.length === 0
              ? "No Driver available"
              : nearest_drivers.join(""),
          assignedDriver: item?.assignDriverdata
            ? item?.assignDriverdata?.firstName +
            " " +
            item?.assignDriverdata?.lastName
            : "-",
        });

        setListData(tableData);
      }
    } else {
      setListData([]);
    }
  }, [driverAssignLogs]);

  return (
    <>
      {listData.length > 0 ? (
        <>
          <div className="px-9 py-5  border-gray-250 border-b w-full ">
            <h2 className="font-semibold text-base mb-3">{t("driverLogs")}</h2>
            <div className="relative w-full overflow-auto">
              <table className="w-full text-left text-sm  text-gray-500">
                <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
                  <tr>
                    <th scope="col" className="px-3 py-3 whitespace-nowrap">
                      {t("branchZoneDetails")}
                    </th>
                    <th scope="col" className="px-3 py-3 whitespace-nowrap">
                      {t("branchDetails")}
                    </th>
                    <th scope="col" className="px-3 py-3 whitespace-nowrap">
                      {t("totalOrderVolume")}
                    </th>
                    <th scope="col" className="px-3 py-3 whitespace-nowrap">
                      {t("onlineDrivers")}
                    </th>
                    <th scope="col" className="px-3 py-3 whitespace-nowrap">
                      {t("driversBasedVehicleType")}{" "}
                    </th>
                    <th scope="col" className="px-3 py-3 whitespace-nowrap">
                      {t("notAvailableDrivers")}{" "}
                    </th>
                    <th scope="col" className="px-3 py-3 whitespace-nowrap">
                      {t("availableDrivers")}
                    </th>
                    <th scope="col" className="px-3 py-3 whitespace-nowrap">
                      {t("nearestDrivers")}
                    </th>
                    <th scope="col" className="px-3 py-3 whitespace-nowrap">
                      {t("totalSlotDistance")}
                    </th>
                    <th scope="col" className="px-3 py-3 whitespace-nowrap">
                      {t("orderDistance")}
                    </th>
                    <th scope="col" className="px-3 py-3 whitespace-nowrap">
                      {t("slotTripDistance")}
                    </th>
                    <th scope="col" className="px-3 py-3 whitespace-nowrap">
                      {t("assignedDriver")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {listData.length > 0
                    ? listData?.map((item, index) => (
                      <>
                        <tr className="bg-white border-b">
                          <td className="px-3 py-4 vertical-top whitespace-nowrap">
                            {item.branchZoneDetail}
                          </td>
                          <td className="px-3 py-4 vertical-top whitespace-nowrap">
                            {item.branchDetail}
                          </td>
                          <td className="px-3 py-4 vertical-top whitespace-nowrap">
                            {item.totalOrderVolume}
                          </td>
                          <td className="px-3 py-4 vertical-top">
                            {item.onlineDriver}
                          </td>
                          <td className="px-3 py-4 vertical-top">
                            {item.driversBasedVehicleType}
                          </td>
                          <td className="px-3 py-4 vertical-top">
                            {item.notAvailableDriver}
                          </td>
                          <td className="px-3 py-4 vertical-top">
                            {item.availableDriver}
                          </td>
                          <td className="px-3 py-4 vertical-top">
                            {item.nearestDrivers}
                          </td>
                          <td className="px-3 py-4 vertical-top">
                            {item?.totalSlotDistance}
                          </td>
                          <td className="px-3 py-4 vertical-top">
                            {item?.orderDistance}
                          </td>
                          <td className="px-3 py-4 vertical-top">
                            {item?.totalTripDistance}
                          </td>
                          <td className="px-3 py-4 vertical-top">
                            {item.assignedDriver}
                          </td>
                        </tr>
                      </>
                    ))
                    : null}
                  {/* <tr>
                  <td colSpan={9} className="text-center mt-3">
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </td>
                </tr> */}
                </tbody>
              </table>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};
export default DriverLogs;
